import { Resource } from 'src_common/common/mobx-utils/Resource';
import { observable, makeAutoObservable } from 'mobx';
import { apiCommon } from 'src/api/ApiCommon';
import { CountrySettingsType } from 'src/api/config/admin/getCountries';

export class CountriesState {
    @observable public countries: Resource<CountrySettingsType>;

    public constructor() {
        this.countries = new Resource(async (): Promise<CountrySettingsType> => {
            const response = await apiCommon.adminGetCountries.run({});
            return response;
        });
        makeAutoObservable(this);
    }
}
